export const environment = {
  production: true,
  apiBaseUrl: "https://customerportalapiprod-app.azurewebsites.net/",
  msalRedirect: "https://shop.ppg.tikkurila.com"
};
